import type { HistogramChartYAxisProps } from '../types/histogram.js';

export const YAxis = (props: HistogramChartYAxisProps) => null;

YAxis['displayName'] = 'HistogramChart.YAxis';
